import { MeetingBotStatus, MeetingParticipant, MeetingParticipantStatus } from './meetingInterfaces'

export const StatusToLabelMap = {
  [`${MeetingBotStatus.BotLeaving}`]: 'Stopping...',
  [`${MeetingBotStatus.BotJoining}`]: 'Starting...',
  [`${MeetingBotStatus.Error}`]: 'An error occurred',
  [`${MeetingBotStatus.Inactive}`]: 'Inactive',
  [`${MeetingBotStatus.Recording}`]: 'Recording',
  [`${MeetingBotStatus.Waiting}`]: 'Waiting for permission...',
}

export const StatusToButtonTextMap = {
  [`${MeetingBotStatus.Inactive}`]: 'Start Recording',
  [`${MeetingBotStatus.Recording}`]: 'Stop Recording',
}

export const enum EmailRequestStatus {
  Requesting = 'requesting',
  Requested = 'requested',
  Failed = 'failed',
  PermissionDenied = 'permission_denied',
  Error = 'error',
  NotRequested = 'not_requested',
}

export const EmailRequestStatusToLabelMap = {
  [`${EmailRequestStatus.Requesting}`]: 'Requesting...',
  [`${EmailRequestStatus.Requested}`]: 'Requested',
  [`${EmailRequestStatus.Failed}`]: 'Failed',
  [`${EmailRequestStatus.PermissionDenied}`]: 'Permission Denied',
  [`${EmailRequestStatus.Error}`]: 'Error',
  [`${EmailRequestStatus.NotRequested}`]: 'Not Requested',
}

export const getParticipantStatus = (participant: MeetingParticipant) => {
  switch (participant.status) {
    case MeetingParticipantStatus.Idle:
    case MeetingParticipantStatus.Error:
      if (participant.linkedInInfo) {
        const info = participant.linkedInInfo
        return {
          text: info.person?.headline || 'No title available',
        }
      }
      return {
        text: 'No LinkedIn info available',
      }
    case MeetingParticipantStatus.LoadingInfo:
      return {
        text: 'Loading LinkedIn info...',
      }
    case MeetingParticipantStatus.RequestedEmail:
      return {
        text: 'Waiting for email permission...',
      }
    default:
      return {
        text: 'Unknown status',
      }
  }
}
